import React from 'react';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { usePreferencesStore } from '@/store/usePreferencesStore';

const LANGUAGES = [
  { code: 'en', label: 'English', flag: '🇺🇸' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'hi', label: 'हिंदी', flag: '🇮🇳' },
  { code: 'ja', label: '日本語', flag: '🇯🇵' },
  { code: 'pt-br', label: 'Português', flag: '🇧🇷' },
] as const;

type LanguageCode = (typeof LANGUAGES)[number]['code'];

export const LanguageSwitcher: React.FC = () => {
  const language = usePreferencesStore((s) => s.language) as LanguageCode ?? 'en';
  const setLanguage = usePreferencesStore((s) => s.setLanguage);

  const current = LANGUAGES.find((l) => l.code === language) ?? LANGUAGES[0];

  return (
    <Select value={language} onValueChange={(v) => setLanguage(v as LanguageCode)}>
      <SelectTrigger
        className="h-8 w-auto min-w-0 gap-1 border-none bg-transparent px-2 text-xs shadow-none hover:bg-accent hover:text-accent-foreground focus:ring-0"
        title="Switch language"
      >
        <SelectValue>
          <span className="flex items-center gap-1">
            <span>{current.flag}</span>
            <span className="uppercase">{current.code}</span>
          </span>
        </SelectValue>
      </SelectTrigger>
      <SelectContent align="end">
        {LANGUAGES.map((lang) => (
          <SelectItem key={lang.code} value={lang.code} className="text-xs">
            <span className="flex items-center gap-2">
              <span>{lang.flag}</span>
              <span>{lang.label}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
